"use strict";
var Ajaxinate = function (e) {
  var i = e || {},
    n = {
      pagination: ".magepow-Pagination",
      method: "scroll",
      container: ".magepow-Loop",
      offset: 0,
      loadingText: "Loading more...",
      callback: null,
    };
  this.settings = Object.assign(n, i);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function () {
  if (this.containerElement) {
    var e = { click: this.addClickListener, scroll: this.addScrollListeners };
    e[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function () {
  if (this.paginationElement) {
    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function () {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (e) {
  e.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  var e = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
    i = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    
  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.removeScrollListener();

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.loadMore();
  }
};

Ajaxinate.prototype.loadMore = function () {
  if (!this.nextPageUrl) {
    console.error("No next page URL found.");
    return;
  }

  fetch(this.nextPageUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error("Failed to load more products.");
      }
      return response.text();
    })
    .then(html => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");
      let newContent = doc.querySelector(this.settings.container);
      let newPagination = doc.querySelector(this.settings.pagination);

      if (newContent) {
        requestAnimationFrame(() => {
          this.containerElement.insertAdjacentHTML("beforeend", newContent.innerHTML);
        });
      }

      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
        this.initialize(); // Reinitialize for next pages
      } else {
        this.paginationElement.style.display = "none"; // Hide pagination if no more pages
      }

      if (this.settings.callback && typeof this.settings.callback === "function") {
        this.settings.callback(doc);
      }
    })
    .catch(error => console.error(error));
};

Ajaxinate.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  var e = { click: this.removeClickListener, scroll: this.removeScrollListener };
  e[this.settings.method]();
  return this;
};